import { useParams , useLocation} from 'react-router-dom';
import React, { useState,useEffect } from 'react';
import ScheduleBanner from './ScheduleBanner';
import DynamicAnswerSubmit from './DynamicAnswerSubmit';
import { TextField, Button, Box,Typography, Tab } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import QuestionAnswerList from './QuestionAnswerList';
import {main_url  , DARK_BLUE} from  './basefile';

import FloatingbackButton from './Floatbt_backy.jsx';
import FloatinglogoutButton from './Floatbt_logout';

const SchedulePage = () => {

  const { proId, ptid, scheduleId, exeid, scheddt,status, wsize } = useParams();

 // alert("pro ID" + proId +"sch ID " +scheduleId + "execu ID "+ exeid + "sch date " + scheddt+ "status:" + status);
// alert(wsize);
  const [selectedDate, setSelectedDate] = useState('');
  const [isDateSaved, setIsDateSaved] = useState(false);
  const [showQuestionnaires, setShowQuestionnaires] = useState(false);
  const [shstatus, setShstatus] = useState('');
  const [showanserlist, setShowanserlist] = useState(false);
  const [showQAButton, setShowQAButton] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const sampleData = {
    patientID: ptid,
    projectID: proId,
    scheduleId: 0,
    date: '',
  };


function isWithinWindow(scheduleDate, windowSize) {
  const actual = new Date(scheduleDate);
   actual.setHours(0, 0, 0, 0);

  const wsize = isNaN(Number(windowSize)) ? 0 : Number(windowSize);

  // Start = scheduleDate - wsize
  const start = new Date(actual);
  start.setDate(start.getDate() - wsize);

  // End = scheduleDate + wsize
  const end = new Date(actual);
  end.setDate(end.getDate() + wsize);

  // Current date (ignore time part)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today >= start && today <= end;

}

function check_range()
{
  if(isWithinWindow(scheddt,wsize)){
    //alert("true");
    setShowQAButton(true);
  }else{
    //alert("false");
    }
}


  const get_all_schedule = async () => {

    try {
            const token  = localStorage.getItem('authToken');  
            
            const res = await fetch(`${main_url}/api/v1/executions/${exeid}/schedules/`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            });
    
            if (!res.ok) throw new Error('Failed to fetch schedules');
    
            let data = await res.json();

            data = data.results.reverse();

           // alert(JSON.stringify(data));
            
            setSchedules(data || []);
          } catch (error) {
            console.error('Error fetching schedules:', error);
            setSchedules([]);
          } finally {
            setLoading(false);
          }
        };
  
const revisitallschedue = (
      updateditem) => {

    let lastValidDate = updateditem.actual_date ? new Date(updateditem.actual_date) : new Date();

    const max_size = schedules.length;
    const cur_index = updateditem.order;
    const current = updateditem;
    

      for (let i = cur_index + 1 ; i <= max_size; i++) {
          
          // list index start from 0 
          const next = schedules[i-1];

           //alert( "max " + max_size + "Cur index " + (cur_index+1) + "nextitem " + next.order + "date " + next.actual_date);

            // Stop chain if next is dynamic
            if (next.schedule_type === 'dynamic') continue;

            // Calculate next date
            //const baseDate = lastValidDate;
            const baseDate = new Date(lastValidDate);
            baseDate.setDate(baseDate.getDate() + parseInt(next.interval, 10));
            const formattedDate = baseDate.toISOString().split('T')[0];
            lastValidDate = formattedDate;

            //alert( "new date" + formattedDate);
            handleUpdatemode(next.id,formattedDate);
      }
  };

  const handleUpdateSchedule = () => {

    const execution_pk = exeid;
    const schedule_pk = scheduleId;
    const token = localStorage.getItem('authToken');

    const url = `${main_url}/api/v1/executions/${execution_pk}/schedules/${schedule_pk}/`;

    const payload = {
      actual_date: selectedDate,
      completed_at: null,
      note: 'NA',
    };

    fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {

        alert('Schedule updated successfully.');
        //alert(JSON.stringify(data.schedule_type));
        setIsDateSaved(true); 

        revisitallschedue(data);

        // we need to re-adjust all below scdule if current is dynamic
         // Only start chain if updated item is dynamic
        //if (updatedItem.schedule_type === 'dynamic') {
          //revisitallschedue();

          //await recalculateAndChainUpdate(updatedIndex, newSchedules, handleUpdateMode);
        //}
       

      })
      .catch((err) => {
        alert('Main call Failed to update schedule.'+ err);
         setIsDateSaved(true); 
      });
  };


  const handleUpdatemode = (scheduleIdnew,newdate) => {

    const execution_pk = exeid;
    const schedule_pk = scheduleIdnew;
    const token = localStorage.getItem('authToken');

    const url = `${main_url}/api/v1/executions/${execution_pk}/schedules/${schedule_pk}/`;

    const payload = {
      actual_date: newdate,
      completed_at: null,
      note: 'NA',
    };

    fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
        // need snakbar msg
         //alert('Schedule updated successfully.');
         // setIsDateSaved(true);
      })
      .catch((err) => {
        alert('recur Failed to update schedule.');
         setIsDateSaved(true); 
      });
  };


  const handleShowQuestionnaires = () => {
    setShowQuestionnaires(true);
    
  };

   const handleAnswerQuestionnaires = () => {
    //setShowQuestionnaires(true);
    //alert("hhhh");
    setShowanserlist(true);    
  };




   useEffect(() => {
     // read schedule detail 
     setShstatus(status);
     //alert("second" + status);
     setIsDateSaved(true); 

     // check the window and enable Q&A button
     check_range();
     get_all_schedule();

   }, []);

  return (
    <Box sx={{bgcolor: '#dde7ecff'}}
>
      <Box
        sx={{ pt:3, 
          height: 150,
          bgcolor:   DARK_BLUE,
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          borderRadius: 0,

        }}
      >
        <Typography variant="h4" fontWeight="bold" mt={5}>
          Schedule
        </Typography>
      </Box>
  <br></br>
      <ScheduleBanner
        patientID={sampleData.patientID}
        projectId={sampleData.projectID}
        scheduleId={scheduleId}
        date= {scheddt}
        status = {status}
      />
     <br></br>
      <Box mt={3} display="flex" justifyContent="center" gap={2}>
       
        {
          shstatus == 'completed' ? (
             <Button variant="contained" color="secondary" onClick={handleAnswerQuestionnaires}>
                Show  Questionnaires
              </Button>
              
          ):(
             <Box>
              <Button variant="contained" color="primary" onClick={() => setIsDateSaved(false)} sx={{backgroundColor:'#245463'}}>
          Update Schedule
        </Button> <Tab></Tab>
       

            
  {showQAButton && (
             <Button variant="contained" color="secondary" onClick={handleShowQuestionnaires} sx={{backgroundColor:'#245463'}}>
              Answer Questionnaires
              </Button>
  )}

               </Box>

          ) 
        }

      </Box>

      {!isDateSaved && (
        <Box
          ml={35}
          mt={10}
          width="520px"
          bgcolor="#f2f5f4ff"
          p={2}
          borderRadius={2}
          boxShadow={1}
          display="flex"
          flexDirection="column"
          gap={2}
          
          
        >
          <DatePicker
            label="Select Date"
            format="MM/DD/YYYY"
            value={selectedDate ? dayjs(selectedDate) : null}
            onChange={(value) => setSelectedDate(value && value.isValid() ? value.format('YYYY-MM-DD') : '')}
            slotProps={{
              textField: {
                fullWidth: true,
                InputLabelProps: {
                  shrink: true,
                  sx: { fontWeight: 'bold', fontSize: '1.2rem' },
                },
              },
            }}
          />

          <Button
            variant="contained"
           sx={{backgroundColor:'#245463', }}
            onClick={() => {
              if (!selectedDate) {
                alert('Please select a date before saving.');
                return;
              }
              handleUpdateSchedule();
            }}
          >
            Save
          </Button>
        </Box>
      )}


<br></br>
 {showanserlist && (
  
  <QuestionAnswerList  execid ={ exeid} schdid = { scheduleId } />
 )}
      {showQuestionnaires && (
        <Box mt={6}>
          <DynamicAnswerSubmit project_pk={proId} execution_pk={exeid} schedule_pk={scheduleId} />
        </Box>
      )}
      <br></br>
   
      <br>
      </br>
            <br>
      </br>
        <br>
      </br>
      

     <FloatingbackButton />
     

    </Box>
  );
};

export default SchedulePage;
